import Friends from './friends'

export default Friends